// @generated by protobuf-ts 2.9.1 with parameter optimize_code_size
// @generated from protobuf file "v2/concordium/health.proto" (package "concordium.health", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * Parameters to the node health query. The default message gives a good
 * default.
 *
 * @generated from protobuf message concordium.health.NodeHealthRequest
 */
export interface NodeHealthRequest {
}
/**
 * Response to the health check. A return code of "OK" is used for success, and
 * errors are handled via RPC status codes
 *
 * @generated from protobuf message concordium.health.NodeHealthResponse
 */
export interface NodeHealthResponse {
}
// @generated message type with reflection information, may provide speed optimized methods
class NodeHealthRequest$Type extends MessageType<NodeHealthRequest> {
    constructor() {
        super("concordium.health.NodeHealthRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message concordium.health.NodeHealthRequest
 */
export const NodeHealthRequest = new NodeHealthRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NodeHealthResponse$Type extends MessageType<NodeHealthResponse> {
    constructor() {
        super("concordium.health.NodeHealthResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message concordium.health.NodeHealthResponse
 */
export const NodeHealthResponse = new NodeHealthResponse$Type();
/**
 * @generated ServiceType for protobuf service concordium.health.Health
 */
export const Health = new ServiceType("concordium.health.Health", [
    { name: "Check", options: {}, I: NodeHealthRequest, O: NodeHealthResponse }
]);
